import { doLogin } from "../data/apiClient";

export const authRepository = {
    doLogin: async (credentials) => {
        try {
            const response = await doLogin(credentials);
            return { success: response.status === 200 };
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { success: false, message: 'Invalid username or password' };
            } else {
                return { success: false, message: 'An unexpected error occurred' };
            }
        }
    },
}